import { Button, GridRow } from "designSystem/index";
import React from "react";

export default () => {
	return (
		<GridRow>
			<Button
				design="secondary"
				res="Button1"
			/>
			<Button
				design="primary"
				res="Button2"
			/>
			<Button
				design="secondary"
				res="Button3"
			/>
			<Button
				design="secondary"
				res="Button4"
			/>
			<Button
				design="primary"
				res="Button5"
			/>
			<Button
				design="secondary"
				res="Button6"
			/>
			<Button
				design="secondary"
				res="Button1"
			/>
			<Button
				design="primary"
				res="Button2"
			/>
			<Button
				design="secondary"
				res="Button3"
			/>
			<Button
				design="secondary"
				res="Button4"
			/>
			<Button
				design="primary"
				res="Button5"
			/>
			<Button
				design="secondary"
				res="Button6"
			/>
			<Button
				design="secondary"
				res="Button1"
			/>
			<Button
				design="primary"
				res="Button2"
			/>
			<Button
				design="secondary"
				res="Button3"
			/>
			<Button
				design="secondary"
				res="Button4"
			/>
			<Button
				design="primary"
				res="Button5"
			/>
			<Button
				design="secondary"
				res="Button6"
			/>
			<Button
				design="secondary"
				res="Button1"
			/>
			<Button
				design="primary"
				res="Button2"
			/>
			<Button
				design="secondary"
				res="Button3"
			/>
			<Button
				design="secondary"
				res="Button4"
			/>
			<Button
				design="primary"
				res="Button5"
			/>
			<Button
				design="secondary"
				res="Button6"
			/>
		</GridRow>
	);
};